import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppContext from '../../../Context/AppContext';
import config from '../../../config';
import requestAxios from '../../../util/requestAxios';
import { guardPortalV2Route } from '../../../util/portalV2';
import { getFrameworkUpgradeUrl } from '../../../util/portalAccess';
import UserMenu from '../../DashboardV2/UserMenu/UserMenu';
import '../portalV2Shared.css';
import './NonSubscriberV2.css';

/**
 * Portal V2 non-subscriber landing — parallel to /NonSubscriber.
 * Login destination; user can upgrade or open the limited Dashboard V2 shell.
 */
const NonSubscriberV2 = () => {
    const { checkUserSession } = useContext(AppContext);
    const history = useHistory();
    const session = checkUserSession() || {};
    const { token, userId } = session;

    const [profile, setProfile] = useState(null);
    const [avatarBust, setAvatarBust] = useState(0);

    useEffect(() => {
        guardPortalV2Route(history, '/NonSubscriber');
    }, [history]);

    useEffect(() => {
        if (!token || !userId) return undefined;

        let cancelled = false;

        (async () => {
            const { error, data } = await requestAxios({
                url: `Customer/GetCustomerProfileInfo/${userId}`,
                token,
            });
            if (!cancelled && !error && data) {
                setProfile(data);
                setAvatarBust(Date.now());
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [token, userId]);

    const upgradeUrl = getFrameworkUpgradeUrl(config);

    const goToDashboard = () => {
        history.push('/dashboard-v2');
    };

    return (
        <div className="pv2 pv2-nonsub">
            <header className="pv2-nonsub__top">
                <UserMenu
                    profile={profile}
                    avatarBust={avatarBust}
                    onOpenProfile={() => history.push('/dashboard-v2?profile=1')}
                />
            </header>

            <div className="pv2-nonsub__card pv2-glass pv2-glass--strong pv2-anim">
                <p className="pv2-eyebrow">Membership</p>
                <h1 className="pv2-title">
                    Unlock your full
                    <br />
                    Oola experience
                </h1>
                <p className="pv2-sub">
                    Hi{session.firstName ? ` ${session.firstName}` : ''}. Your
                    account is active, but a subscription is needed to access
                    the Action Tracker, e-learning, and your life blueprint.
                </p>
                <ul className="pv2-nonsub__perks">
                    <li>Design My Life Blueprint (Steps 1–3)</li>
                    <li>Daily Action Tracker &amp; goals</li>
                    <li>Breakthrough, Path &amp; Additional programs</li>
                </ul>
                <div className="pv2-nonsub__actions">
                    <button
                        type="button"
                        className="pv2-btn pv2-btn--ghost"
                        onClick={goToDashboard}
                    >
                        Go to dashboard
                    </button>
                    <a
                        className="pv2-btn pv2-btn--primary"
                        href={upgradeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Upgrade to continue →
                    </a>
                </div>
            </div>
        </div>
    );
};

export default NonSubscriberV2;
